// removed by extract-text-webpack-plugin
module.exports = {"avatar":"_1Lxic3QAw7EI_ftvKy9hGg"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Avatar/avatar.pcss
// module id = 854
// module chunks = 0